module.exports = __webpack_public_path__ + "static/media/line-chart-logo.a34ce156.svg";